import { RegionProps } from "app/types/region";
import {
  ADDRESS_DISTRICT,
  ADDRESS_REGIONS,
  APPEAL_INFO,
  BASE_URL,
  CONFIRM,
  CONFIRM_RESET, MY_REPORT,
  REGISTER,
  RESET_PASSWORD,
} from "./URLs";
import { DistrictProps } from "app/types/district";
import {
  JshirRegisterRequestConfirmProps,
  JshirRegisterRequestProps,
} from "app/types/jshirregister";
import onlyNumber from "app/helpers/onlyNumber";
import moment from "moment";
import axios from "axios";
import { api } from ".";
import { TeacherAppealProps } from "app/types/teacherAppeal";

// GET regions: Server should return RegionProps
export const getRegions = async () => {
  const { data } = await axios.get<RegionProps[]>(
    `${BASE_URL}${ADDRESS_REGIONS}`
  );
  return data;
};

// GET districts: Server should return DistrictProps
export const getDistrict = async (id: number) => {
  const { data } = await axios.get<DistrictProps[]>(
    `${BASE_URL}${ADDRESS_DISTRICT}${id}/`
  );
  return data;
};

// POST register
export const requestJshirRegister = async (
  jshir: string,
  firstname: string,
  lastname: string,
  familiyname: string,
  birthdate: string,
  gender: string,
  region: string,
  district: string,
  password: string,
  phone: string
) => {
  const data = await axios.post<JshirRegisterRequestProps>(
    `${BASE_URL}${REGISTER}`,
    {
      birthday: moment(birthdate).format("YYYY-MM-DD"),
      district: district,
      family_name: familiyname,
      first_name: firstname,
      gender: gender,
      jshir: jshir,
      last_name: lastname,
      organization: 1,
      password: password,
      phone: onlyNumber(phone),
      region: region,
    }
  );
  return data;
};

// POST register phone confirm: Server should return <JshirRegisterRequestConfirmProps>
export const requestJshirRegisterConfirmPhone = async (
  code: number,
  phone: string
) => {
  const data = await axios.post<JshirRegisterRequestConfirmProps>(
    `${BASE_URL}${CONFIRM}`,
    {
      code,
      phone,
    }
  );
  return data;
};

// POST restore password add and confirm number: Server should return <bolean>
export const requestRestorePasswordNumber = async (
  phone: string,
  otp: number
) => {
  const data = await axios.post(`${BASE_URL}${RESET_PASSWORD}`, {
    phone,
    code: otp,
  });
  return data;
};

export const requestRestorePAsswordNew = async (password: string, password2: string, phone: string, code: number) => {
  const data = await axios.post(`${BASE_URL}${CONFIRM_RESET}`, {
    code,
    phone,
    password,
    password2
  });
  return data;
};

export const getTeacherAppeal = async () => {
  const data = await api.get<TeacherAppealProps>(APPEAL_INFO)
  return data.data
}

export const getTeacherReport = async () => {
  const data = await api.get<TeacherAppealProps>(MY_REPORT)
  return data.data
}

export const postTeacherReport = async (message: string, title: string, phone: string, address: string, file: any) => {
  const data = await api.post(`${BASE_URL}${MY_REPORT}`, {
    address,
    phone,
    message,
    title,
    file
  });
  return data;
};